import React, { useContext, useState } from "react";
import AdminRegistrationContext from "../../context/adminRegistration/adminRegistrationContext";
import * as GrIcons from "react-icons/gr";

const SiteItem = ({ data, setSite, selectedSite }) => {
  const {
    name,
    charter,
    address: { state, address_1, city, zip },
    coordinates,
  } = data;
  return (
    <tr>
      <td>{name}</td>
      <td>{charter}</td>
      <td>{`${address_1}, ${city}, ${state}, ${zip}`}</td>
      {Object.keys(selectedSite).length === 0 && (
        <td>
          <div
            onClick={() => {
              setSite(data);
            }}
            className="btn btn-llac-light-grey"
          >
            Select
          </div>
        </td>
      )}
    </tr>
  );
};

const SiteFieldSearchModal = ({ setLocationInfo }) => {
  const [search, setSearch] = useState("");
  const [selectedSite, setSelectedSite] = useState("");
  const adminRegistrationContext = useContext(AdminRegistrationContext);
  const {
    setFormModal,
    filteresSearchSites,
    filterSearchSites,
    clearfilteredSearchSites,
    getOrientationInformation,
  } = adminRegistrationContext;

  return (
    <div id="site-field-search-modal" className="modal">
      <div className="field-modal-content modal-content">
        <div className="top-bar">
          <GrIcons.GrFormClose
            className="close-icon"
            onClick={() => setFormModal("siteFieldSearchModal", false)}
          />
          <h2>Search Sites by Fields</h2>
        </div>
        <div className="modal-body">
          <div className="search-bar form">
            <input
              type="search"
              value={search}
              placeholder="Search Sites by Fields"
              onChange={(e) => {
                if (e.target.value == "") {
                  clearfilteredSearchSites();
                } else {
                  filterSearchSites(e.target.value);
                }
                setSearch(e.target.value);
                setSelectedSite({});
              }}
            />
          </div>
          <div className="search-results">
            <table>
              <tr>
                <th>Name</th>
                <th>Charter</th>
                <th>Address</th>
                {Object.keys(selectedSite).length === 0 && <th>Action</th>}
              </tr>
              {filteresSearchSites.length > 0 ? (
                Object.keys(selectedSite).length !== 0 ? (
                  <SiteItem
                    data={selectedSite}
                    setSite={setSelectedSite}
                    selectedSite={selectedSite}
                  />
                ) : (
                  filteresSearchSites.map((item) => {
                    return (
                      <SiteItem
                        data={item}
                        setSite={setSelectedSite}
                        selectedSite={selectedSite}
                      />
                    );
                  })
                )
              ) : null}
            </table>
          </div>
        </div>
        <div className="bottom-bar">
          <div className="btns">
            {Object.keys(selectedSite).length !== 0 && (
              <div
                onClick={() => {
                  setSearch("");
                  clearfilteredSearchSites();
                  setLocationInfo({
                    id: selectedSite.id,
                    name: selectedSite.name,
                    charter: selectedSite.charter,
                    address: `${selectedSite.address.address_1}, ${selectedSite.address.city}, ${selectedSite.address.state}, ${selectedSite.address.zip}`,
                    coordinates: selectedSite.address.coordinates,
                  });
                  console.log({
                    id: selectedSite.id,
                    name: selectedSite.name,
                    charter: selectedSite.charter,
                    address: `${selectedSite.address.address_1}, ${selectedSite.address.city}, ${selectedSite.address.state}, ${selectedSite.address.zip}`,
                    coordinates: selectedSite.address.coordinates,
                  });
                  getOrientationInformation(selectedSite.id);
                  setFormModal("siteFieldSearchModal", false);
                }}
                className={`btn btn-llac-dark-green`}
              >
                Confirm Site
              </div>
            )}
            <div
              className="btn btn-l4l-dark"
              onClick={() => setFormModal("siteFieldSearchModal", false)}
            >
              Close
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SiteFieldSearchModal;
